import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios'
type RetriableAxiosConfig = AxiosRequestConfig & { sent?: boolean }
import { getAccessToken, handleRefreshSession } from '../utils/cognito'

const baseURL = import.meta.env.PROD
  ? import.meta.env.VITE_APP_PROD_API_URL
  : import.meta.env.VITE_APP_DEV_API_URL

const client: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'x-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json;charset=utf-8'
  }
})

client.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const accessToken: string | null = getAccessToken()

    if (accessToken) {
      // axios v0.24 uses plain object headers
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${accessToken}`
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

client.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error) => {
    const config = (error?.config || {}) as RetriableAxiosConfig

    if (error?.response?.status === 401 && !config?.sent) {
      config.sent = true

      await handleRefreshSession()

      return await client(config)
    }
    return Promise.reject(error)
  }
)

export default function getAxios(): AxiosInstance {
  return client
}
